$(document).ready(function(){

  $(".cls-key-ingredients").click(function(){
      let index = $(this).data('index');
      $(".cls-key-ingredients-wrap").removeClass('active');
      $(this).parent().addClass('active')
      $(".cls-key-ingredients-image").hide();
      $(".cls-key-image-ingredients-"+index).show();
  });

    $(".feature_progress_text.slider-for")
      .slick({
          infinite: true,
          autoplay:false,
          autoplaySpeed:2000,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          fade: false,
          pauseOnHover:true
      });

    $(".feature_progress_text_2 .slider-for")
      .slick({
          infinite: true,
          autoplay:false,
          autoplaySpeed:2000,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          fade: false,
          pauseOnHover:true
      });
      
  $(".cls-img-icon-text-wrapper .slider-for")
    .slick({
        infinite: true,
        autoplay:false,
        autoplaySpeed:2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: false,
        pauseOnHover:true,
        prevArrow: backButton,
        nextArrow: nextButton,
        responsive: [
          {
            breakpoint: 989,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }

        ]
    });



  $(".collection-tabs li").click(function(){
    const id = $(this).data('id');
    const $slider = $("#Slider-" + id);
    const $parent = $(this).closest('.antr--collection-tabs');

    $slider.parents('.collection').find(".contains-card").removeClass('active');
    $slider.addClass('active');

    $parent.find(".collection-tabs li").removeClass('active');
    $(this).addClass('active');
  
    $parent.find(".contains-card--product").hide().css('opacity', 0);
    
    $slider.show().slick('refresh');

    setTimeout(() => $slider.css('opacity', 1), 500);
  });

  $(".collapsibles_tab .product__accordion-heading").click(function () {
    const $parent = $(this).closest(".collapsibles_tab");
    const $content = $parent.find(".accordion__contents");

    $(".collapsibles_tab").not($parent).removeClass("active")
      .find(".accordion__contents").slideUp();

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
    }
  });


  $(".footer-block .footer-block__heading").click(function () {
    const $parent = $(this).closest(".footer-block");
    const $content = $parent.find(".footer-block__details-content");
    const $content1 = $parent.find(".footer-block__brand-info");

    $(".footer-block").not($parent).removeClass("active")
      .find(".footer-block__details-content").slideUp();

    $(".footer-block").not($parent).removeClass("active")
      .find(".footer-block__brand-info").slideUp();      

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
      $content1.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
      $content1.slideDown();
    }
  });
  
});

document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".animation-number");

    const animateNumber = (el, target, formatFn) => {
        const duration = 2000;
        const startTime = performance.now();

        const step = (currentTime) => {
            const progress = Math.min((currentTime - startTime) / duration, 1);
            const value = progress * target;

            el.textContent = formatFn(value);

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = formatFn(target); // đảm bảo kết thúc chính xác
            }
        };

        requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const el = entry.target;
                const raw = el.textContent.trim();
                const match = raw.match(/^([\d.]+)([a-zA-Z%+]+)?$/);

                if (!match) return;

                let num = parseFloat(match[1]);
                let suffix = match[2] || "";
                let target = num;
                let formatFn;

                suffix = suffix.toUpperCase();

                if (suffix === "K+" || suffix === "K") {
                    target = num * 1000;
                    formatFn = (val) => Math.floor(val / 1000) + "K+";
                } else if (suffix === "M+" || suffix === "M") {
                    target = num * 1000000;
                    formatFn = (val) => Math.floor(val / 1000000) + "M+";
                } else if (suffix === "%") {
                    formatFn = (val) => Math.floor(val) + "%";
                } else if (suffix === "X") {
                    formatFn = (val) => val.toFixed(1) + "X";
                } else {
                    formatFn = (val) => Math.floor(val) + suffix;
                }

                animateNumber(el, target, formatFn);
                obs.unobserve(el);
            }
        });
    }, { threshold: 0.4 });

    counters.forEach((counter) => observer.observe(counter));
});
